import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	FakturaceprofilId: null as number | null,
	LakSzbNahr: null as number | null,
	LakdruhOzn: null as string | null,
	LakdruhOznText: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VyrobekvozOzn: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { VyrobekvozOzn: [] },
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.NAHRADNI_SAZBA_LAK_DRUH_SELECT_MAPPER](state, { data }) {
			state.edit.LakdruhOzn = data.value;
			state.edit.LakdruhOznText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
